const commonAndMisc = {
  errorMessage404: "おっと！探しているページは存在しません", // translated
  errorContentUnavailable:
    "おっと！探しているコンテンツは存在しません。問題についてはお問い合わせください", // translated
  backToHome: "家に帰る", // translated
  information: "情報", // translated
  additionalInformation: "追加情報", // translated
  destinationPlaceholder: "目的地", // translated
  aboutUs: "私たちについて", // translated
  pleaseWait: "お待ちください...", // translated
  featuredHotels: "注目のホテル", // translated
  topPackages: "トップパッケージ", // translated
  topTours: "人気のツアー", // translated
  traveller: "旅行者", // translated
  reviews: "レビュー", // translated
  home: "ホーム", // translated
  packages: "パッケージ", // translated
  experiences: "体験談", // translated
  close: "近い", // translated
  loadingMessage: "利用可能な最安値を検索するまでお待ちください。", // translated
  loadingMessageTheHotelCo: "利用可能な最安値を検索するまでお待ちください。", // translated
  loadingMessageSearchStrip: "最安値を検索中。しばらくお待ちください", // translated

  stillSearchingHotels:
    "Still searching — {{priced}} of {{discovered}} hotels priced",
  hotelsProgressCount: "Found {{priced}} of {{discovered}} hotels",
  searchingSuppliers: "Checking {{suppliers}}",
  topCountriesToVisit: "訪問先のトップ国", // translated
  profile: "プロフィール", // translated // translated 
  reservations: "予約", // translated
  address: "住所", // translated
  firstName: "ファーストネーム", // translated
  lastName: "苗字", // translated
  email: "Eメール", // translated
  login: "ログイン", // translated
  logout: "ログアウト", // translated
  myProfile: "私のプロフィール", // translated
  verified: "確認済み", // translated
  unverified: "未検証", // translated
  selectLanguage: "言語を選択する", // translated
  selectCurrency: "通貨を選択してください", // translated
  upgrade: "アップグレード", // translated
  membership: "メンバーシップ", // translated
  travelTrust: "トラベルトラスト", // translated
  signInUp: "サインイン/アップ", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates:
    "世界中のホテルやリゾートを驚きの卸売価格でご提供", // translated
  dashboard: "ダッシュボード", // translated
  pricing: "価格設定", // translated
  refundable: "返金可能", // translated
  cars: "車", // translated
  cruises: "クルーズ", // translated
  view: "詳細をみる", // translated
  price: "価格", // translated
  totalPrice: "合計金額", // translated
  filterRoomName: "フィルタールーム名", // translated
  get: "得る", // translated
  guestInformationValidation: "ゲスト情報の検証", // translated
  reservation: "予約", // translated
  checkIn: "チェックイン", // translated
  checkOut: "チェックアウト", // translated
  paymentInitiattionErroeMessage:
    "お支払いプロセスを開始できませんでした。ご不便をおかけしてしまい申し訳ございません", // translated
  warning: "警告", // translated
  couldNotFindPriceForDateWarning:
    "この日付の価格は見つかりませんでした。別の日付でもう一度お試しください", // translated
  searchFormValidationError: "検索フォーム検証エラー", // translated
  pleaseSelectValidDateFirst: "最初に有効な日付を選択してください", // translated
  searchError: "検索エラー", // translated
  priceSearchInitiationError:
    "価格検索プロセスを開始できませんでした。後でもう一度試してください。ご不便をおかけしてしまい申し訳ございません", // translated
  searchWarning: "検索の警告", // translated
  couldNotFindPriceAndOrAvailability:
    "ご要望に応じた価格や在庫状況が見つかりませんでした。ご不便をおかけしてしまい申し訳ございません", // translated
  joinNow: "今すぐ参加", // translated
  signIn: "サインイン", // translated
  searchNow: "検索中", // translated
  bookingFailed: "予約に失敗しました", // translated
  sorryForTheInconvenience: "ご不便をおかけしてしまい申し訳ございません", // translated
  paymentFailedTryAgain: "支払いに失敗しました。もう一度試してください", // translated
  quickLinks: "クイックリンク", // translated
  tours: "ツアー", // translated
  termsAndConditions: "利用規約", // translated
  pleaseWaitWhileInitiatingPayment:
    "お支払い手続きを開始するまでお待ちください。", // translated
  back: "戻る", // translated
  nextStep: "次のステップ", // translated
  book: "本", // translated
  checkout: "チェックアウト", // translated
  specifyPickUpPoint: "ご希望のピックアップ場所を指定してください", // translated
  pickupPoint: "集荷場", // translated
  optional: "オプション", // translated
  remarks: "備考", // translated
  travellerInformation: "旅行者情報", // translated
  bookingRemarks: "予約に関する備考", // translated
  bookingOverview: "予約概要", // translated
  paymentFailed: "支払いに失敗しました", // translated
  paymentSuccess: "支払い成功", // translated
  at: "で", // translated // translated 
  person: "人", // translated
  cancellationPolicy: "取り消し規約", // translated
  From: "から", // translated // translated 
  to: "に", // translated
  cancellationIs: "キャンセルは", // translated
  pickup: "選び出す", // translated
  flights: "フライト", // translated
  Accommodation: "宿泊施設", // translated
  payAndBook: "支払いと予約", // translated
  onRequest: "要求に応じて", // translated
  weAreFindingTheBestAvailableServices:
    "利用可能な最高のサービスを探しています", // translated
  withTheBestAvailablePrices: "最良の価格で", // translated
  inRealTime: "リアルタイムで", // translated
  seconds: "秒", // translated // translated 
  thisProcessCanTakeUpToOneMinute:
    "このプロセスには最大 1 分かかる場合があります", // translated
  pleaseDoNotRefreshThisPage: "このページを更新しないでください", // translated
  wellItSeemsItCanTakeBitLonger: "そうですね…もう少し時間がかかりそうです", // translated
  yourBrowserDoesNotSupportTheVideoTag:
    "お使いのブラウザはビデオタグをサポートしていません", // translated
  bookingSuccess: "予約成功", // translated
  bookingReference: "予約番号", // translated
  referenceCopied: "参照をコピーしました", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation:
    "間もなく、ご予約に必要な情報がすべて記載されたメールが届きます。", // translated
  viewMore: "もっと見る", // translated
  readMore: "続きを読む", // translated
  customerSupport: "顧客サポート", // translated
  socialMedia: "ソーシャルメディア", // translated
  hours: "時間", // translated // translated 
  hour: "時間", // translated // translated 
  minutes: "分", // translated // translated 
  minute: "分", // translated // translated 
  memberId: "メンバーID", // translated
  star: "星", // translated
  stars: "出演者", // translated
  proceed: "進む", // translated
  clearAllFilters: "すべてのフィルターをクリア", // translated
  clearYourFilters:
    "結果を表示するにはフィルター オプションをクリアしてください", // translated
  noOptionsForSelectedFilters: "フィルタに一致するオプションはありません", // translated
  privacyPolicy: "プライバシーポリシー", // translated
  security: "安全", // translated
  nearby: "近く", // translated
  distanceFromSelection: "選択範囲からの距離", // translated
  km: "km", // translated
  restaurants: "レストラン", // translated
  active: "アクティブ", // translated
  visitSite: "サイトに訪れる", // translated
  score: "スコア", // translated
  applicationAvailable: "利用可能なアプリケーション", // translated
  sendUsEmail: "私たちにメールを送って", // translated
  sendUsYourRequest: "リクエストをお送りください", // translated
  notAvailable: "利用不可", // translated
  found: "見つかった", // translated
  progressAt: "での進捗状況", // translated
  currency: "通貨", // translated
  sendUsRequest: "リクエストをお送りください", // translated
  noReservationsForThisProduct: "この商品は予約不可です", // translated
  confirmed: "確認済み", // translated
  cancelled: "キャンセル", // translated
  pending: "保留中", // translated
  status: "状態", // translated
  reference: "参照", // translated
  leadGuest: "リードゲスト", // translated
  sendVoucherEmail: "バウチャーメールを送信する", // translated
  sendCancellationEmail: "キャンセルメールを送信する", // translated
  downloadVoucher: "クーポンをダウンロード", // translated
  emailHasBeenSent: "メールが正常に送信されました", // translated
  emailNotSentTryAgain: "メールが送信されませんでした!もう一度試してください", // translated
  titleIsRequired: "タイトルは必須です", // translated
  genderIsRequired: "性別は必須です", // translated
  firstNameMustContainAlphabetic:
    "名にはアルファベットのみを含める必要があります", // translated
  firstNameIsRequired: "名は必須です", // translated
  lastNameIsRequired: "姓は必須です", // translated
  lastNameMustContainAlphabetic: "姓には英字のみを含める必要があります", // translated
  phoneNumberInTheFormat:
    "電話番号はスペースを含まない形式にする必要があります", // translated
  phoneNumberIsRequired: "電話番号は必須です", // translated
  emailIsRequired: "メールアドレスは必須です", // translated
  invalidEmail: "無効な電子メール", // translated
  addressIsRequired: "住所は必須です", // translated
  cityIsRequired: "市区町村は必須です", // translated
  postalCodeIsRequired: "郵便番号は必須です", // translated
  countryIsRequired: "国は必須です", // translated
  yourReservationIsInProgress: "ご予約は進行中です", // translated
  clickHere: "ここをクリック", // translated
  iHaveReadAgreeWithAbove: "上記を読み、同意します", // translated
  pleaseCheckTheBox:
    "次のステップに進む前に、提供された情報を読んで同意したことを示すボックスにチェックを入れてください。", // translated
  myPoints: "マイポイント", // translated
  myBookings: "私の予約", // translated
  provideImportantInfoForYourTravel:
    "ご旅行中に重要な情報がございましたらお知らせください", // translated
  ourContactNumbersAre: "弊社の連絡先番号は、", // translated
  noBookingsForThisProduct: "この商品の予約はありません", // translated
  myAccount: "私のアカウント", // translated
  contactUsToAssistWithYourBooking:
    "ご予約のお手伝いをさせていただきますので、お気軽にお問い合わせください。ご不便をおかけしてしまい申し訳ございません", // translated
  monday: "月曜日", // translated
  saturday: "土曜日", // translated
  operationalHours: "営業時間", // translated
  monday_to_friday: "月曜日から金曜日まで", // translated
  friday: "金曜日", // translated
  thursday: "木曜日", // translated
  tuesday: "火曜日", // translated
  sunday: "日曜日", // translated
  wednesday: "水曜日", // translated
  closed: "閉まっている", // translated
  notConfirmed: "無効", // translated // translated 
  topUpPoints: "ポイントアップ", // translated
  on: "の上", // translated
  nationality: "国籍", // translated
  gender: "性別", // translated
  amountIn: "金額", // translated 
  pleaseAcceptProperty: "予約しようとしている物件がご希望の物件であることを示すため、上部のチェックボックスにチェックを入れてください。", // translated 
  myQuotations: "私の引用", // translated 
  myChatRooms: "マイチャット", // translated 
  chatRoomsListEmpty: "このアカウントにはチャットルームがありません。", // translated 
  chatRoomsOpen: "開ける", // translated 
  chatRoomsLastActivity: "最後のアクティビティ", // translated 
  chatRoomsUnread: "未読", // translated 
  chatRoomsBadgeQuotation: "見積もり", // translated 
  chatRoomsBadgeTripOffer: "旅行プラン", // translated 
  chatRoomsOpenQuotationAria: "見積もりチャットを開く: {{name}}", // translated 
  chatRoomsOpenTripOfferAria: "旅行オファーチャットを開く: {{name}}", // translated 
  chatRoomsOpenGenericAria: "チャットを開く: {{name}}", // translated 
  quotationChatInvalidLink:
    "有効なチャットリンクです。プロフィールまたは見積もり一覧からチャットを開くか、room_code または room_uid のいずれか 1 つのみを使用してください。", // translated 
  quotationChatNoTripDetails: "このチャットでは旅行の詳細は利用できません。", // translated 
  chat: "チャット", // translated 
  amountOut: "支払金額", // translated 
  yourReservationHasBeenRegistered: "ご予約が登録されました", // translated 
  maintenanceTitle: "サイトはメンテナンス中です", // translated 
  maintenanceDescription:
    "定期メンテナンスを実施しています。しばらくしてからもう一度ご確認ください。", // translated 
  maintenanceCountdownLabel: "残り時間の目安", // translated 
  maintenanceLogoAlt: "サイトのロゴ", // translated 
  maintenanceDays: "日", // translated 
  maintenanceHours: "時間", // translated 
  maintenanceMinutes: "分", // translated 
  maintenanceSeconds: "秒", // translated 
  maintenanceStatusBadge: "定期メンテナンス", // translated 
  maintenanceRefresh: "ページを更新", // translated 
  maintenanceExpired:
    "メンテナンスはまあすぐ完了する安心です。ページを更新してください。", // translated 
};


export default commonAndMisc;
